/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationPackagesAliases {
  ACTION_ADD = 'action-add',
  AUTOCOMPLETE_TYPE = 'autocomplete-type',
  AUTOCOMPLETE_TYPE_EDIT = 'autocomplete-type-edit',
  AUTOCOMPLETE_TYPE_LIST = 'autocomplete-type-list',
  CARD_PROCEDURE = 'card-procedure',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FETCH_ACTION = 'fetch-action',
  FETCH_AUTOCOMPLETE = 'fetch-autocomplete',
  FETCH_AUTOCOMPLETE_EDIT = 'fetch-autocomplete-edit',
  FETCH_AUTOCOMPLETE_LIST = 'fetch-autocomplete-list',
  FETCH_EDIT_PACKAGE = 'fetch-edit-package',
  FETCH_PACKAGES = 'fetch-packages',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_0 = 'field-0',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_41 = 'field-41',
  FIELD_51 = 'field-51',
  FIELD_ACTION = 'field-action',
  FIELD_AMOUNT = 'field-amount',
  FIELD_AMOUNT_EDIT = 'field-amount-edit',
  FIELD_AMOUNT_EDIT_LIST = 'field-amount-edit-list',
  FIELD_AUTOCOMPLETE = 'field-autocomplete',
  FIELD_AUTOCOMPLETE_EDIT = 'field-autocomplete-edit',
  FIELD_DS_PROCEDURE = 'field-dsProcedure',
  FIELD_ITEM = 'field-item',
  FIELD_ITEM_AMOUNT = 'field-item-amount',
  FIELD_ITEM_EDIT = 'field-item-edit',
  FIELD_ITEM_LIST = 'field-item-list',
  FIELD_ITEM_LIST_EDIT = 'field-item-list-edit',
  FIELD_MAIN = 'field-main',
  FIELD_MAIN_PROCEDURE = 'field-main-procedure',
  FIELD_MEDICINE_MATERIAL = 'field-medicine-material',
  FIELD_MEDICINE_MATERIAL_EDIT = 'field-medicine-material-edit',
  FIELD_PACKAGE_VALUE = 'field-package-value',
  FIELD_PROCEDURE = 'field-procedure',
  FIELD_PROCEDURE_EDIT = 'field-procedure-edit',
  FIELD_RADIO_BUTTON = 'field-radio-button',
  FIELD_RADIO_BUTTON_EDIT = 'field-radio-button-edit',
  FIELD_TOAST = 'field-toast',
  FIELD_TYPE = 'field-type',
  FIELD_TYPE_EDIT = 'field-type-edit',
  FIELD_TYPE_PROCEDURE = 'field-type-procedure',
  FIELD_VALUE = 'field-value',
  FILED_ACTION_STATUS = 'filed-action-status',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_0 = 'form-0',
  FORM_EDIT_PACKAGE = 'form-edit-package',
  FORM_ITEM = 'form-item',
  FORM_ITEM_EDIT = 'form-item-edit',
  FORM_MAIN_PROCEDURE = 'form-main-procedure',
  INPUT_0 = 'input-0',
  INPUT_5 = 'input-5',
  INPUT_10 = 'input-10',
  INPUT_ITEM = 'input-item',
  INPUT_VALUE_PACKAGE = 'input-value-package',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_CONTENT = 'layout-content',
  LEGENDS = 'legends',
  LINK_ADD = 'link-add',
  LINK_ADD_ITEM = 'link-add-item',
  LOADER_0 = 'loader-0',
  LOCATOR_FIELD_CDITEM = 'locator-field-cditem',
  LOCATOR_ITEM = 'locator-item',
  LOCATOR_MEDICINE_MATERIAL = 'locator-medicine-material',
  LOCATOR_MEDICINE_MATERIAL_EDIT = 'locator-medicine-material-edit',
  LOCATOR_PROCEDURE = 'locator-procedure',
  LOCATOR_PROCEDURE_EDIT = 'locator-procedure-edit',
  MAPPER_0 = 'mapper-0',
  MAPPER_3 = 'mapper-3',
  MAPPER_10 = 'mapper-10',
  MAPPER_101 = 'mapper-101',
  MAPPER_LIST = 'mapper-list',
  MAPPER_REVISION = 'mapper-revision',
  MODAL_ADD_PACKAGE = 'modal-add-package',
  MODAL_EDIT = 'modal-edit',
  PANEL_0 = 'panel-0',
  PANEL_ADD = 'panel-add',
  PANEL_ADD_ITEM = 'panel-add-item',
  PANEL_CARD_EDIT = 'panel-card-edit',
  PANEL_EDIT = 'panel-edit',
  PANEL_FORM_ITEM_EDIT = 'panel-form-item-edit',
  PANEL_ITEM_LIST = 'panel-item-list',
  PANEL_ITEM_LIST_EDIT = 'panel-item-list-edit',
  PANEL_LINK_ADD_ITEMS = 'panel-link-add-items',
  PANEL_LOADER = 'panel-loader',
  PANEL_MODAL = 'panel-modal',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_SAVE = 'panel-save',
  PANEL_TITLE = 'panel-title',
  RADIO_GROUP_PACKAGE_TYPE = 'radio-group-package-type',
  RADIO_GROUP_PACKAGE_TYPE_EDIT = 'radio-group-package-type-edit',
  TEXT = 'text',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_01 = 'text-01',
  TEXT_3 = 'text-3',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
  TEXT_12 = 'text-12',
  TEXT_54 = 'text-54',
  TEXT_66 = 'text-66',
  TEXT_IE_SPECIALTY = 'text-ieSpecialty',
  TEXT_IE_SPECIALTY_EDIT = 'text-ieSpecialty-edit',
  TEXT_LIST = 'text-list',
  TEXT_LIST_EDIT = 'text-list-edit',
  TEXT_TYPE_PROCEDURE = 'text-type-procedure',
  TOAST_NOTIFICATION = 'toast-notification',
  TOAST_PENDENCIES = 'toast-pendencies',
  UNBOXED_AUTOCOMPLETE_ACTION = 'unboxed-autocomplete-action',
  WIZARD_PACKAGE = 'wizard-package',
  WIZARD_STEP_COMPOSITION = 'wizard-step-composition',
  WIZARD_STEP_MAIN = 'wizard-step-main',
}
export { AccreditationPackagesAliases };
